enum SubscriptionTypeEnum {
    PAPER = 1,
    BIOMETRIC = 2,
    REMOTE = 3,
}

export default SubscriptionTypeEnum